import { render } from "./usertransactions.vue?vue&type=template&id=73f6462d"
import script from "./usertransactions.vue?vue&type=script&lang=js"
export * from "./usertransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__